<script setup lang="ts">
import type { RtpProperties } from '@/pages/nstc/db/nstc-rtp-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'NSTCRTP',
    },
})

const orgType = ref('C')
const userNo = ref()
const cName = ref()
// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  orderByCol.value = options.sortBy[0]?.key
  sortOrder.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '選手代碼', key: 'userNo' },
    { title: '姓名', key: 'cName' },
    { title: '蘗檢對像', key: 'isTester' },
    { title: '更新記錄', key: 'isUpdateRecord' },
    { title: '更新時間', key: 'updTimestamp' },

]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: rtpDatas, execute: fetchRtp, isFetching: loading  } = await useApi<any>(createUrl('/nstc/rtp/api', {
  query: {
    userNo,
    cName,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): RtpProperties[] => rtpDatas.value.content)
const totalDatas = computed(() => rtpDatas.value.totalElements)

console.log('datas: ', datas)


const statusText = (status: string) => {
  switch (status) {
    case 'T':
      return '是'
    case 'F':
      return '否'
    default:
      return '-'
  }
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol cols="12" sm="2" >
          <AppTextField
            v-model="userNo"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入選手代碼"
          />
        </VCol>
        <VCol cols="12" sm="3" class="px-4">
          <AppTextField
            class=""
            v-model="cName"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入選手姓名"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />


    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            :loading="loading"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.userNo="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.userNo }}
          </div>
      </template>

      <template #item.cName="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.cName }}
          </div>
      </template>

      <template #item.isTester="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ statusText(item.isTester) }}
          </div>
      </template>

      <template #item.isUpdateRecord="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ statusText(item.isUpdateRecord) }}
          </div>
      </template>

      <template #item.updTimestamp="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ formatDateTime(item.updTimestamp) }}
          </div>
      </template>


      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>

</template>
